export const REQUIRED_FIELD_MSG = 'This field is required'
export const INVALID_FIRST_NAME_MESSAGE = 'First Name is not valid'
export const INVALID_LAST_NAME_MESSAGE = 'Last Name is not valid'
export const REQUIRED_COLLECTION_MSG =
  'This collection is required. At least one value must be selected.'
export const INVALID_EMAIL_MSG = 'Email is not valid'
export const INVALID_PHONE_MSG = 'Phone number is not valid'
export const REQUIRED_FILE_MSG = 'No file selected'
export const INVALID_PASSWORD_MSG = 'Password must meet all requirements.'
export const INVALID_ACCESS_CODE_MSG = 'Verification code incorrect or expired.'
export const MOBILE_NUMBER_DUPLICATE_ERROR =
  'Unable to validate provided phone number. Enter a different phone number or contact support.'
export const ADDRESS_SEARCH_INPUTS_REQUIRED =
  'Address search requires street address, city, state and zip code.  Fill in the missing fields and try again.'
